module.exports = __webpack_public_path__ + "img/节点触发一键导入_1.b81aaf68.svg";